import React, { useState, useRef } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const ImageSlider = ({ images }) => {
    const [scrollPosition, setScrollPosition] = useState(0);
    const containerRef = useRef(null);

    const scrollLeft = () => {
        if (containerRef.current) {
            containerRef.current.scrollBy({
                top: 0,
                left: -150,
                behavior: 'smooth',
            });
            setScrollPosition(scrollPosition - 150);
        }
    };

    const scrollRight = () => {
        if (containerRef.current) {
            containerRef.current.scrollBy({
                top: 0,
                left: 150,
                behavior: 'smooth',
            });
            setScrollPosition(scrollPosition + 150);
        }
    };

    return (
        <div className="relative w-full flex items-center px-4 overflow-hidden">
            <button
                onClick={scrollLeft}
                className="absolute left-0 z-10 p-2 ml-4 bg-gray-700 text-white rounded-full focus:outline-none"
            >
                <FaArrowLeft size={24} />
            </button>

            {
                images?.length <= 5
                    ?
                    <div
                        ref={containerRef}
                        className="flex justify-center overflow-hidden w-full space-x-2 sm:space-x-4"
                    >
                        {images?.map((image, index) => (
                            <img
                                key={index}
                                className="w-20 h-20 sm:w-48 sm:h-48 object-cover rounded"
                                src={image}
                                alt={`article-img-${index}`}
                            />
                        ))}
                    </div>
                    :
                    <div
                        ref={containerRef}
                        className="flex overflow-hidden w-full space-x-2 sm:space-x-4"
                    >
                        {images?.map((image, index) => (
                            <img
                                key={index}
                                className="w-20 h-20 sm:w-48 sm:h-48 object-cover rounded"
                                src={image}
                                alt={`article-img-${index}`}
                            />
                        ))}
                    </div>
            }

            <button
                onClick={scrollRight}
                className="absolute right-0 mr-4 z-10 p-2 bg-gray-700 text-white rounded-full focus:outline-none"
            >
                <FaArrowRight size={24} />
            </button>
        </div>
    );
};

export default ImageSlider;
